(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview/assets/javascripts/invitation-hero.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview/assets/javascripts/invitation-hero.js');
"use strict";


const {
  useCallback,
  useEffect,
  useRef
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useHistory,
  useRouteMatch
} = ReactRouterDOM;
const {
  Hero
} = svs.components.marketplaceCompetition.hero;
const Button = svs.ui.ReactButton;
const {
  CompetitionErrorCode
} = svs.components.marketplaceShared.invitation;
const {
  FetchState
} = svs.components.marketplaceCompetition.constants;
const {
  showDialogAction
} = svs.components.marketplaceCompetition.services.actions.dialogActions;
const {
  isCurrentMember,
  selectTeamInvitationStatus
} = svs.components.marketplaceCompetition.services.selectors;
const {
  setPlayerCompetitionSignedUp
} = svs.components.marketplaceCompetition.services.actions.playerCompetitionActions;
const {
  joinTeamByInvitation
} = svs.components.marketplaceCompetition.services.actions.teamsActions;
const {
  processErrorCode
} = svs.components.marketplaceShared.competitionErrorCodes;
const {
  competitionNames,
  CompetitionType
} = svs.components.marketplaceCompetition.constants;
const {
  resolveCompetitionName
} = svs.components.marketplaceCompetition.helpers;
const logger = svs.core.log.getLogger('marketplace-competition:invitation-hero');
const {
  useCompetition,
  useCompetitionBranding
} = svs.components.marketplaceCompetition.services.hooks;
const InvitationHero = _ref => {
  let {
    invitation
  } = _ref;
  const {
    competitionId,
    teamId,
    invitationId
  } = invitation;
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    params
  } = useRouteMatch();
  const invitationStatus = useSelector(selectTeamInvitationStatus);
  const userIsCurrentMember = useSelector(state => isCurrentMember(state, invitation.competitionId, invitation.teamId));
  const comp = useCompetition(competitionId);
  const compType = comp === null || comp === void 0 ? void 0 : comp.compType;
  const competitionBranding = useCompetitionBranding(compType);
  const autoJoinTriggered = useRef(false);
  const autoJoin = useRef(svs.utils.url.queryString.autoJoin === 'true');
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const teamName = window.decodeURIComponent(invitation.teamName);
  const {
    tipsSmRulesDocumentId,
    tipsEmRulesDocumentId,
    policyPersonalData
  } = svs.tipsen.data.competition;
  const rulesDocumentId = compType === CompetitionType.TipsEM ? tipsEmRulesDocumentId : tipsSmRulesDocumentId;
  const getErrorDialogContent = useCallback((err, teamId) => {
    var _err$responseJSON;
    const {
      errorCode,
      errorMessage,
      errorTitle
    } = processErrorCode((_err$responseJSON = err.responseJSON) === null || _err$responseJSON === void 0 ? void 0 : _err$responseJSON.error);
    let buttons = [];
    switch (errorCode) {
      case CompetitionErrorCode.ALREADY_PARTICIPATE:
        buttons = [{
          text: 'OK, ta mig dit!',
          callback: () => {
            history.push("/tavlingar/".concat(params.competitionName, "/lag/").concat(teamId));
          }
        }];
        break;
      default:
        buttons = [{
          text: 'Okej',
          callback: () => {
            history.push("/tavlingar/".concat(params.competitionName));
          }
        }];
        break;
    }
    return {
      title: errorTitle,
      text: errorMessage,
      type: 'error',
      icon: 'exclamation-sign',
      buttons
    };
  }, [history, params.competitionName]);
  const onClickLoginAndJoinTeam = () => {
    window.location.assign("/logga-in?returnUrl=".concat(window.location.pathname, "?autoJoin=true"));
  };
  const onClickJoinTeam = async () => {
    let hasRejected;
    try {
      await dispatch(joinTeamByInvitation({
        competitionId,
        teamId,
        invitationId
      })).unwrap();
    } catch (err) {
      if (err.name !== 'ConditionError') {
        var _err$responseJSON2, _err$responseJSON3;
        hasRejected = true;
        const errorDialogContent = getErrorDialogContent(err, teamId);
        dispatch(showDialogAction(errorDialogContent));
        logger.info("invitationhero code: ".concat((_err$responseJSON2 = err.responseJSON) === null || _err$responseJSON2 === void 0 || (_err$responseJSON2 = _err$responseJSON2.error) === null || _err$responseJSON2 === void 0 ? void 0 : _err$responseJSON2.code, ", message: ").concat(((_err$responseJSON3 = err.responseJSON) === null || _err$responseJSON3 === void 0 || (_err$responseJSON3 = _err$responseJSON3.error) === null || _err$responseJSON3 === void 0 ? void 0 : _err$responseJSON3.message) || err.message));
      }
    } finally {
      if (!hasRejected) {
        await dispatch(setPlayerCompetitionSignedUp({
          competitionId
        }));
        svs.components.analytics.trackEvent({
          category: compType,
          action: 'joined team',
          opt_label: 'Lag'
        });
        dispatch(showDialogAction({
          title: 'Välkommen in i omklädningsrummet',
          text: "Du har nu g\xE5tt med i ".concat(teamName),
          icon: 'players',
          buttons: [{
            text: 'Schysst',
            callback: () => {
              history.push("/tavlingar/".concat(params.competitionName, "/lag/").concat(teamId, "?fromJoin=true"));
            }
          }]
        }));
      }
    }
  };
  useEffect(() => {
    if (autoJoin.current && !autoJoinTriggered.current) {
      autoJoinTriggered.current = true;
      autoJoin.current = false;
      const query = new URLSearchParams(history.location.search);
      query.set('autoJoin', 'false');
      history.replace({
        search: query.toString()
      });
      onClickJoinTeam();
    }
    return () => {
      autoJoin.current = false;
    };
  }, []);
  useEffect(() => {
    if (userIsCurrentMember) {
      dispatch(showDialogAction({
        title: "Du \xE4r redan medlem i \u201C".concat(teamName, "\u201D"),
        icon: 'help-2',
        buttons: [{
          text: 'Ta mig dit!',
          callback: () => {
            history.push("/tavlingar/".concat(params.competitionName, "/lag/").concat(invitation.teamId));
          }
        }]
      }));
    }
  }, [dispatch, history, invitation.teamId, params.competitionName, teamName, userIsCurrentMember]);
  return React.createElement(Hero, {
    branding: competitionBranding,
    competitionId: parseInt(competitionId, 10),
    horizontal: "center",
    vertical: "middle"
  }, React.createElement("div", {
    className: "f-center overview-invitation"
  }, React.createElement("h2", {
    className: "f-800"
  }, "Du har blivit inbjuden till", React.createElement("br", null), teamName), React.createElement("p", null, "Anm\xE4lan till ".concat(resolveCompetitionName(comp), " ").concat(competitionNames.TIPS_SM_YEAR)), Boolean(isLoggedIn) && React.createElement(Button, {
    className: "qa-competition-overview-hero-login-button",
    "data-testid": "qa-join-team",
    disabled: invitationStatus === FetchState.Pending,
    onClick: onClickJoinTeam
  }, "G\xE5 med i laget"), !isLoggedIn && React.createElement(Button, {
    className: "qa-competition-overview-hero-login-button",
    "data-testid": "qa-join-team",
    disabled: invitationStatus === FetchState.Pending,
    onClick: onClickLoginAndJoinTeam
  }, "Logga in och g\xE5 med i laget"), React.createElement("p", null, "Genom att g\xE5 med i ett lag godk\xE4nner du", React.createElement("br", null), React.createElement("a", {
    className: "qa-rules join-team-rules-link",
    href: "/dokument/".concat(rulesDocumentId),
    rel: "noreferrer",
    target: "_blank"
  }, "regler och villkor f\xF6r ".concat(resolveCompetitionName(comp))), ".", React.createElement("br", null), React.createElement("br", null), "Information g\xE4llande\xA0", React.createElement("a", {
    className: "qa-rules-personal join-team-rules-link",
    href: "/dokument/".concat(policyPersonalData),
    rel: "noreferrer",
    target: "_blank"
  }, "behandling av personuppgifter"))));
};
setGlobal('svs.components.marketplaceCompetition.overview.InvitationHero', InvitationHero);

 })(window);